
export const TITLE_SIZE_1 = 44;
export const TITLE_SIZE_2 = 32;
export const TITLE_SIZE_3 = 24;
export const TITLE_SIZE_4 = 18;
export const TITLE_SIZE_5 = 14;
export const TITLE_SIZE_6 = 12;

export const FAMILY_FONT_PRIMARY = 'Fjalla One';
export const FAMILY_FONT_SECONDARY = 'Noto Sans';
export const FAMILY_FONT_CONTROL = 'Nunito Sans';
export const FAMILY_FONT_EXTRA = 'Maven Pro';
